module.exports = __webpack_public_path__ + "img/6.b62b4e10.jpg";